import {
	missionHeroImage,
	missionHeroMobileImage,
	missionImage,
	purposeImage,
	tenetsImage,
	valueImage,
} from "../images";

export const heroData = [
	{
		heading: "Mission, Vision, Purpose and Guiding Principles",
		imageSource: [missionHeroImage, missionHeroMobileImage],
	},
];

export const missionVisionData = [
	{
		imageSource: missionImage,
		heading: "Our MISSION",
		subHeading: "To promote and teach Holistic Education.",
		description: [
			"We create a sustainable platform and culture that teaches Holistic Education",
			"We develop the intellectual, emotional, moral, social and physical well-being of community members",
			"We create an enabling environment to support the vulnerable members of our communities",
			"We develop a sustainable empowerment program to support children and youths",
			"We develop support programs to address social issues affecting youths and families",
		],
		link: "/about-us/our-mission-vision-purpose/our-mission",
	},
	{
		imageSource: purposeImage,
		heading: "Our PURPOSE",
		subHeading: "Relief Poverty, Community Development & Youth Empowerment",
		description: [
			"Relieve poverty by providing basic necessities of life to the vulnerable members of our communities ",
			"Advance education through youth empowerment seminars and training programs",
			"Address specific problems faced by the children, youth and families through support programs",
			"Relieve conditions associated with aged and people with disability through empowerment programs",
		],
		link: "/about-us/our-mission-vision-purpose/our-purpose",
	},
	{
		imageSource: tenetsImage,
		heading: "What Drives Us",
		subHeading: "To promote and teach Holistic Education.",
		description: [
			"An intelligent Head with an honest Heart will make selfless community-oriented decisions",
			"An intelligent Head needs a skillful Hand to effectively utilize her potentials",
			"An intelligent Head, honest Heart and skillful Hand will be an agent for a true and sustainable community development",
		],
		link: "/about-us/our-mission-vision-purpose/our-tenets",
	},
	{
		imageSource: valueImage,
		heading: "Guiding Principles",
		subHeading: "How we operate",
		description: [
			"Integrity: We are accountable, honest and upright",
			"Resourcefulness: We continuously explore new ways to overcome difficulties",
			"Collaboration: We work as a team to support our community",
			"Excellence: We are committed to delivering outstanding performance",
			"Sympathy: We are engaged with the situations happening in our community",
			"Education: We are committed to providing holistic education to support integrated learning in all areas of life",
			"Consistency: We are committed to sustainable community and individual growth",
			"Community: It takes a community to develop a community. We appreciate the contribution of all community members",
		],
		link: "/about-us/our-mission-vision-purpose/guiding-purpose",
	},
];
